import PollOptionModel from "./PollOptionModel";

export default class PreviousPollVoteModel {
  public id: string = null;
  public pollId: string = null;
  public optionIds: string[] = [];
  public optionsModels: PollOptionModel[] = [];
  public userId: string = null;
  public createdAt: string = null;
}
